import VerticalTabs from "common/ComponentSidebar/ComponentSideBar";
import { checkPrivileges } from "Helpers/CheckPrivileges";
import { checkSubscriptions } from "Helpers/CheckSubscriptions";
import { useNavigate } from "react-router-dom";

interface tabProps {
  params: any;
  selectedIndex: number;
}
export default function SupplierTabs(props: tabProps) {
  const navigate = useNavigate();
  const handleChangeTabs = (tabId: number) => {
    if (tabId === 0) navigate(`/supplier/${props.params?.id}`);
    else if (tabId === 1)
      navigate(`/supplier/${props.params?.id}/purchase-orders`);
    else if (tabId === 2) navigate(`/supplier/${props.params?.id}/bills`);
    else if (tabId === 3)
      navigate(`/supplier/${props.params?.id}/stock-receives`);
    else if (tabId === 4) navigate(`/supplier/${props.params?.id}/debit-notes`);
    else if (tabId === 5) navigate(`/supplier/${props.params?.id}/payments`);
  };
  const tabs = [
    { id: 0, title: `edit`, child: <></> },
    { id: 1, title: `Purchase Orders`, child: <></> },
    { id: 2, title: `bills`, child: <></> },
    { id: 3, title: `Stock Received`, child: <></> },
    { id: 4, title: `Debit Notes`, child: <></> },
    { id: 5, title: `payments`, child: <></> },
  ];
  const disableTabs = tabs
    .map((tab) => tab.id)
    .filter((tabId) => {
      switch (tabId) {
        case 0:
          return !checkPrivileges("ROLE_VENDOR_UPDATE");
        case 1:
          return !checkPrivileges("ROLE_PURCHASEORDER_VIEW");
        case 2:
          return !checkPrivileges("ROLE_PURCHASEINVOICE_VIEW");
        case 3:
          return !checkPrivileges("ROLE_STOCKRECEIPT_VIEW");
        case 4:
          return !checkPrivileges("ROLE_PURCHASE_CREDITDEBITNOTE_VIEW");
        case 5:
          return (
            !checkPrivileges("ROLE_PURCHASE_PAYMENT_VIEW") ||
            !checkSubscriptions("PAYMENT")
          );
        default:
          return false;
      }
    });

  return (
    <>
      <VerticalTabs
        tabs={tabs}
        selectedIndex={props.selectedIndex}
        handleChangeTabs={handleChangeTabs}
        disableTabNo={disableTabs}
      />
    </>
  );
}
